import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { History, Printer } from "lucide-react";
import { formatCurrency } from "../../lib/utils";

const dt = (iso) => (iso ? new Date(iso).toLocaleString("pt-PT", { dateStyle: "short", timeStyle: "short" }) : "—");

export const CashSessionsHistory = ({ sessions, onPrint }) => (
  <Card data-testid="cash-sessions-card">
    <CardHeader className="pb-2">
      <CardTitle className="text-base flex items-center gap-2"><History className="w-4 h-4" /> Histórico de aberturas e fechos</CardTitle>
    </CardHeader>
    <CardContent className="p-0">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs text-muted-foreground border-b">
              <th className="px-4 py-2 font-medium">Abertura</th>
              <th className="px-2 py-2 font-medium">Fecho</th>
              <th className="px-2 py-2 font-medium">Operador</th>
              <th className="px-2 py-2 font-medium text-right">Fundo</th>
              <th className="px-2 py-2 font-medium text-right">Vendas</th>
              <th className="px-2 py-2 font-medium text-right">Esperado</th>
              <th className="px-2 py-2 font-medium text-right">Contado</th>
              <th className="px-2 py-2 font-medium text-right">Diferença</th>
              <th className="px-2 py-2 w-24" />
            </tr>
          </thead>
          <tbody>
            {sessions.map((s) => (
              <tr key={s.session_id} className="border-b last:border-0 hover:bg-muted/40" data-testid={`cash-session-row-${s.session_id}`}>
                <td className="px-4 py-2 font-mono text-xs whitespace-nowrap">{dt(s.opened_at)}</td>
                <td className="px-2 py-2 font-mono text-xs whitespace-nowrap">{s.status === "open" ? <Badge className="bg-emerald-500/15 text-emerald-600">Aberta</Badge> : dt(s.closed_at)}</td>
                <td className="px-2 py-2 text-muted-foreground truncate max-w-[140px]">{s.opened_by_name || "—"}</td>
                <td className="px-2 py-2 text-right font-mono">{formatCurrency(s.opening_balance)}</td>
                <td className="px-2 py-2 text-right font-mono">{formatCurrency(s.total_sales)}</td>
                <td className="px-2 py-2 text-right font-mono">{formatCurrency(s.expected_cash)}</td>
                <td className="px-2 py-2 text-right font-mono">{s.closing_balance != null ? formatCurrency(s.closing_balance) : "—"}</td>
                <td className={`px-2 py-2 text-right font-mono font-semibold ${(s.difference || 0) < 0 ? "text-red-600" : (s.difference || 0) > 0 ? "text-emerald-600" : ""}`} data-testid={`cash-session-diff-${s.session_id}`}>
                  {s.difference != null ? `${s.difference > 0 ? "+" : ""}${formatCurrency(s.difference)}` : "—"}
                </td>
                <td className="px-2 py-2 text-right">
                  <Button size="sm" variant="outline" className="gap-1 h-7" onClick={() => onPrint(s)} data-testid={`cash-session-print-${s.session_id}`}><Printer className="w-3.5 h-3.5" /> Relatório</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {sessions.length === 0 && <p className="text-center text-sm text-muted-foreground py-8">Ainda não há sessões de caixa registadas.</p>}
      </div>
    </CardContent>
  </Card>
);
